import axiosService from '../services/axiosService';

const LIST_URL = {
    GET_RECEIPT_INFO: '/paymentport/GetReceiptInfo',
    GET_PAYMENT_INFO: '/paymentport/GetPaymentInfo',
    GET_PAYMENT_TOTAL: '/paymentport/GetPaymentTotal',
    GET_PAYMENT_LINK: '/paymentport/GetPaymentLink',
    GET_VNPT_FORM: '/paymentport/GetVnptEpayForm',
    GET_VNPT_TRANSFER: '/paymentport/GetVnptEpayTransferInfo',
};

const paymentPortApis = {
    /**
     * Lấy thông tin phiếu thu
     * @param {*} receiptId : mã phiếu thu
     * @returns
     */
    getReceiptInfo: (receiptId) => {
        return axiosService.post(`${LIST_URL.GET_RECEIPT_INFO}/${receiptId}`);
    },

    /**
     * Lấy thông tin thanh toán
     * @param {*} receiptId : mã phiếu thu
     * @returns
     */
    getPaymentInfo: (receiptId) => {
        return axiosService.post(`${LIST_URL.GET_PAYMENT_INFO}/${receiptId}`);
    },

    /**
     * Lấy thông phí
     * @param {*} receiptId : mã phiếu thu
     * @param {*} methodId : mã phương thức thanh toán
     * @returns
     */
    getPaymentTotal: (receiptId, methodId) => {
        return axiosService.post(
            `${LIST_URL.GET_PAYMENT_TOTAL}/${receiptId}/${methodId}`
        );
    },

    /**
     * Lấy link thanh toán
     * @param {object} dataPost
     * @param {string} dataPost.receiptId: mã phiếu thu
     * @param {number} dataPost.methodId: mã phương thức thanh toán
     * @returns
     */
    getPaymentLink: (dataPost) => {
        return axiosService.post(LIST_URL.GET_PAYMENT_LINK, dataPost);
    },

    getVnptFormInfo: (dataPost) => {
        return axiosService.post(LIST_URL.GET_VNPT_FORM, dataPost);
    },
    getVnptTransferInfo: (dataPost) => {
        return axiosService.post(LIST_URL.GET_VNPT_TRANSFER, dataPost);
    },
};

export default paymentPortApis;
